import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Tag, Space, Descriptions, Tooltip } from "antd";

const { Title, Text, Paragraph } = Typography;

const ProjectDetailsCard = ({ projectName, owners, description, teamMembers }) => {
console.log(" projectName, owners, description, teamMembers  --->",  projectName, owners, description, teamMembers );
  // Determine how many team members to show initially before a "more" indicator
  const MAX_VISIBLE_TEAM_MEMBERS = 5;
  const visibleTeamMembers = teamMembers?.slice(0, MAX_VISIBLE_TEAM_MEMBERS) || [];
  const hiddenTeamMembersCount = teamMembers ? Math.max(0, teamMembers.length - MAX_VISIBLE_TEAM_MEMBERS) : 0;

  return (
    <Card
      title={<Title level={4} style={{ margin: 0, fontSize: "18px" }}>{projectName || "N/A"}</Title>}
      bordered={true} // A light border can look clean
      style={{
        marginBottom: 16,
        borderRadius: 6, // Slightly smaller border radius
      }}
      headStyle={{padding: "12px 16px"}} // Adjust card header padding
      bodyStyle={{padding: "12px 16px"}} // Adjust card body padding
    >
      <Descriptions layout="horizontal" column={1} size="small" colon={false}>
        <Descriptions.Item 
          labelStyle={{ fontWeight: 500, width: "130px", color: "rgba(0, 0, 0, 0.65)"}} 
          label="Team Owners"
        >
          {owners && owners.length > 0 ? (
            <Space direction="horizontal" wrap size={[4, 4]}> {/* Smaller gap for tags */}
              {owners.map((owner, idx) => (
                <Tag key={idx} color="blue" style={{ margin: "2px" }}> 
                  {owner}
                </Tag>
              ))}
            </Space>
          ) : (
            <Text type="secondary">N/A</Text>
          )}
        </Descriptions.Item>

        <Descriptions.Item 
          labelStyle={{ fontWeight: 500, width: "130px", color: "rgba(0, 0, 0, 0.65)" }} 
          label="Description"
        >
          {description ? (
            <Paragraph 
                ellipsis={{ rows: 3, expandable: true, symbol: "more" }} 
                style={{ marginBottom: 0, fontSize: "14px", color: "rgba(0, 0, 0, 0.85)" }}
            >
              {description}
            </Paragraph>
          ) : (
            <Text type="secondary">No description provided.</Text>
          )}
        </Descriptions.Item>

        <Descriptions.Item 
          labelStyle={{ fontWeight: 500, width: "130px", color: "rgba(0, 0, 0, 0.65)" }} 
          label="Team Members"
        >
          {teamMembers && teamMembers.length > 0 ? (
            <Space direction="horizontal" wrap size={[4, 4]}>
              {visibleTeamMembers.map((member, idx) => (
                <Tag key={idx} bordered={true} style={{ margin: "2px" }}>
                  {member}
                </Tag>
              ))}
              {hiddenTeamMembersCount > 0 && (
                <Tooltip title={teamMembers.slice(MAX_VISIBLE_TEAM_MEMBERS).join(", ")}>
                  <Tag style={{ margin: "2px" }}>
                    +{hiddenTeamMembersCount} more
                  </Tag>
                </Tooltip>
              )}
            </Space>
          ) : (
            <Text type="secondary">No team members added.</Text>
          )}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

ProjectDetailsCard.propTypes = {
  projectName: PropTypes.string.isRequired,
  owners: PropTypes.arrayOf(PropTypes.string).isRequired,
  description: PropTypes.string,
  teamMembers: PropTypes.arrayOf(PropTypes.string),
};

export default ProjectDetailsCard;